import Reveal from "./Reveal";

const SectionTitle = ({ overline, title, sub, align = "left" }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {overline && (
        <Reveal>
          <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#D4AF37] mb-4">
            {overline}
          </p>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className="font-serif tracking-tight text-[#0A192F] text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.1}>
          <p className="mt-6 text-gray-600 text-base sm:text-lg leading-relaxed">{sub}</p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionTitle;
